// LiveStreamKaraokeTooltip.js
import { connect } from 'react-redux';

import LiveStreamKaraokeTooltip from '../component/LiveStreamKaraokeTooltip.jsx';
import getListData from '../selector/getListData.js';
import openLiveStreamKaraokeModal from '../action/openLiveStreamKaraokeModal.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import { karaokeType } from '../resource/goalConstants.js';

const mapStateToProps = (state, { streamId }) => {
  return {
    karaokeIds: getListData(
      state,
      ['liveStream', streamId, 'karaoke', karaokeType.DEFAULT],
      'itemIds'
    ),
  };
};
const mapDispatchToProps = dispatch => {
  return {
    close: () =>
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['liveStream'],
          data: {
            shouldDisplayKaraokeTooltip: false,
          },
        },
      }),
    openLiveStreamKaraokeModal: () => dispatch(openLiveStreamKaraokeModal()),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(LiveStreamKaraokeTooltip);
